import React from 'react';
import styles from './FooterComponent.module.css'

const FooterComponent = () => {
    return (
        <div className={styles.FooterWrapper}>
            <div className={styles.Footer}>
                Copyright &copy; {new Date().getFullYear()} Extra Care Group d.o.o.
            </div>
        </div>
    );
};

export default FooterComponent;
